import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { Select, Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { GetInstructionModel } from '../../models/get-instruction.model';
import { SafePipe } from './../../directives/safe.pipe';
import { GetUserInstruction } from './../../ngxs/action/dashboard.action';
import { DashboardState } from './../../ngxs/state/dashboard.state';

@Component({
  selector: 'app-instructions',
  templateUrl: './instructions.component.html',
  styleUrls: ['./instructions.component.scss'],
})
export class InstructionsComponent implements OnInit, OnDestroy {
  currentLanguage = 'en';

  @Select(DashboardState.userInstructionContent)
  userInstructionContent$: Observable<GetInstructionModel>;

  subscription = new Subscription();
  pdfUrl = '';
  documentMimeType = 'application/pdf';

  constructor(
    private translateService: TranslateService,
    private store: Store,
    private safe: SafePipe
  ) {
    this.currentLanguage = this.translateService.defaultLang;

    this.store.dispatch(new GetUserInstruction(this.currentLanguage));
  }
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  ngOnInit(): void {
    this.subscription.add(
      this.userInstructionContent$.subscribe((x) => {
        if (x) {
          const byteArray = new Uint8Array(
            atob(x.data)
              .split('')
              .map((char) => char.charCodeAt(0))
          );
          this.pdfUrl = window.URL.createObjectURL(
            new Blob([byteArray], { type: 'application/pdf' })
          );
        }
      })
    );
  }
}
